import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor(
    private translate: TranslateService) {
  }

  getValidationErrorMessage(validatorName: string, validatorValue?: any, labelName?: string): any {
    const config = {
      required: this.translate.instant('common.required-field'),
      maxlength: this.translate.instant('errors.max-length', { requiredLength: validatorValue.requiredLength }),
      minlength: this.translate.instant('errors.min-length', { requiredLength: validatorValue.requiredLength }),
      pattern: this.translate.instant('errors.invalid-data-format'),
    };

    return config[validatorName];
  }
}
